import React, { useMemo, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog } from 'primereact/dialog';
import { useParams } from 'react-router-dom';
import { SelectButton } from 'primereact/selectbutton';

import CoverSettingsForm from './CoverSettingsForm';
import MediaAnimationForm from './MediaAnimationForm';

import { useSelector, useDispatch } from 'react-redux';
import { toggleDialog } from '../../../../../../redux/Slices/Global/globalSlice';


function CampaignSettings({ showOption = true, campaignId = null }) {
    const { t } = useTranslation();
    const { id } = useParams();

    const dispatch = useDispatch();
    const { openDialog } = useSelector((s) => s.global);

    const TABS = [
        { key: "cover", title: t('show.show_cover'), icon: <i className="bx bxs-image-alt me-2" /> },
        { key: "animation", title: t('show.show_animation'), icon: <i className="bx bxs-bolt me-2" /> },
    ];

    const [activeTab, setActiveTab] = useState("cover");

    const onHide = () => dispatch(toggleDialog('campaignSettings'));
    const selectedTab = useMemo(() => TABS.find(t => t.key === activeTab) ?? TABS[0], [activeTab]);


    return (
        <Dialog
            header={t('show.show_edit_campaign_settings')}
            visible={openDialog.campaignSettings}
            onHide={onHide}
            breakpoints={{ '960px': '95vw' }}
            style={{ width: '30vw', minHeight: '60vh' ,maxHeight:'100vh'}}
        >
            <div className="d-flex flex-nowrap h-full">


                <div className="w-100 py-3 px-4">
                    <div className="w-100 h-100 flex flex-col items-center justify-start gap-4">
                        {showOption && (
                            <SelectButton
                                optionLabel="title"
                                value={activeTab}
                                onChange={(e) => {
                                    if (e.value) setActiveTab(e.value); // ignore nulls
                                }}
                                options={TABS}
                                optionValue="key"
                                allowEmpty={false}
                            />
                        )}

                        {selectedTab.key === "cover" ? (
                            <CoverSettingsForm campaignId={showOption ? id : campaignId} />

                        ) : (
                            showOption && (<MediaAnimationForm campaignId={showOption ? id : campaignId} />)
                        )}
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default CampaignSettings;
